export default {
  label: {
    series: {
      receivedMessages: 'Received Messages',
      sentMessages: 'Sent Messages',
    },
  },
};
